import { render, staticRenderFns } from "./emailchange.vue?vue&type=template&id=b840f7a2&scoped=true&"
import script from "./emailchange.vue?vue&type=script&lang=ts&"
export * from "./emailchange.vue?vue&type=script&lang=ts&"
import style0 from "./emailchange.vue?vue&type=style&index=0&id=b840f7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b840f7a2",
  null
  
)

export default component.exports